export interface BaseEntity {
  createdAt: dateTimeIOSString;
  updatedAt: dateTimeIOSString;
}

export type int = number;
export type double = number;
export type colorStr = string; //sample #42a5f5 or #de000000
export type dateString = string; // format yyyy-mm-dd
export type dateTimeIOSString = string; // format ios string

export interface ImageObject {
  url: string;
  width: double;
  height: double;
}

export const defaultImageObject: ImageObject = {
  url: "",
  width: 200,
  height: 200,
};

export type AnyObject = {
  [key in string]: any;
};

export interface HtmlDetailData {
  time: number;
  blocks: { type: string; data: any }[];
  version: string;
}

export interface FormRefEvent<T> {
  onSubmit: () => Promise<T>;
  onReset?: (val?: T, noAlert?: boolean) => Promise<T>;
  onFocus?: () => void;
  onCancel?: () => Promise<Partial<T>>;
}

export interface LoadingButtonRefEvent {
  onClick: () => void;
}

export interface TableRefEvent<T> {
  onDelete: (record: T) => void;
}

export interface TableApiRes<T> {
  data: T[];
  total?: number;
  offset?: any;
}

// TODO type
export interface HeadCell {
  id: string;
  label?: string;
  width?: number;
  render?: (
    value?: any,
    record?: any,
    all?: any
  ) => JSX.Element | string | undefined;
}

export interface HtmlDetailData {
  time: number;
  blocks: { type: string; data: any }[];
  version: string;
}

export enum PaginationFilterType {
  "in" = "in",
  between = "between",
  contains = "contains",
  begins_with = "begins_with",
  "greater" = ">",
  "less" = "<",
  "equal" = "=",
  "not_equal" = "<>",
}

export type PaginationFilterValue = {
  key: string;
  type: PaginationFilterType;
  values: (string | number | boolean)[];
};

export interface Pagination {
  limit?: number;
  offset?: any;
  isAll?: boolean; // TODO be careful using it
  needTotal?: boolean;
  filter?: {
    and?: PaginationFilterValue[];
    or?: PaginationFilterValue[];
  };
  attributes?: string[];
}

//same as google map position format
export interface Position {
  lat: number;
  lng: number;
}
